(function ($) {
  var $window = $(window);

  // All Members
  $(function () {
    var page = 1;
    var $search = $('.et_pb_module.et_pb_ld_search');
    var isDisabled = false;

    function AjaxErr(err) {
      console.log(err);
      alert("Sorry, there was an error. Please refresh the page and try again.");
    }

    $search.on('change', 'select', function () {
      $search.find('form').trigger('submit');
    });

    $search.find('form .button').on('click', function () {
      $search.find('form').trigger('submit');
    });

    $search.on('submit', 'form', function (e) {
      e.preventDefault();

      page = 1;
      isDisabled = false;
      $search.find('.ld-posts').empty();
      $search.find('form').trigger('ld.search');
    });

    $window.on('scroll', function (ev) {
      if ((window.innerHeight + window.pageYOffset) >= (document.body.offsetHeight - 100)) {
        if ($search.hasClass('loading')) {
          return;
        }
        page++;
        $search.find('form').trigger('ld.search');
      }
    });

    $search.on('ld.search', 'form', function (e) {
      if (isDisabled) {
        return;
      }

      if ($search.hasClass('loading')) {
        return;
      }

      $search.addClass('loading');
      $.ajax({
        url: window.ld.homeUrl + '/wp-admin/admin-ajax.php?action=Search_GetPosts',
        method: 'POST',
        data: {
          'page': page,
          'term_id': $search.find('select[name="term_id"]').val(),
          'search': $search.find('input[name="search"]').val(),
          'year': $search.find('select[name="year"]').val()
        }
      }).then(function (res) {
        if (!res.success) {
          return AjaxErr(res);
        }

        if (res.result.html) {
          $search.find('.ld-posts').append(res.result.html);
        }

        if (res.result.count === 0) {
          $search.find('.load-more').remove();
          isDisabled = true;
        }
      }, AjaxErr).always(function () {
        $search.removeClass('loading');
      });
    });

    // init
    $search.find('form').trigger('ld.search');
  });
})(jQuery);
